import { render, staticRenderFns } from "./main.vue?vue&type=template&id=127f2976&scoped=true&"
var script = {}
import style0 from "./main.vue?vue&type=style&index=0&id=127f2976&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127f2976",
  null
  
)

export default component.exports